<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>

    <!-- Page Heading -->
    <h1 class="h4 mb-2 text-gray-800">
      <i class="fas fa-cog"></i> Cài đặt hệ thống
    </h1>
    <p class="text-muted mb-4">
      Cấu hình các thiết lập của ứng dụng như người dùng, giao diện, thông báo, cơ sở dữ liệu và các tích hợp.
    </p>

    <div class="card shadow mb-4">
      <div class="card-body">

        <!-- TABS -->
        <ul class="nav nav-tabs" role="tablist">

          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#library">
              <i class="fas fa-book"></i> Chung
            </a>
          </li>

          <li class="nav-item disabled">
            <a class="nav-link disabled" data-toggle="tab" href="#user">
              <i class="fas fa-users-cog"></i> Người dùng
            </a>
          </li>

          <li class="nav-item disabled">
            <a class="nav-link disabled" data-toggle="tab" href="#display">
              <i class="fas fa-paint-brush"></i> Giao diện
            </a>
          </li>

          <li class=" nav-item disabled">
            <a class="nav-link disabled" data-toggle="tab" href="#database">
              <i class="fas fa-database"></i> CSDL
            </a>
          </li>

          <li class="nav-item disabled">
            <a class="nav-link disabled" data-toggle="tab" href="#notification">
              <i class="fas fa-bell"></i> Thông báo
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#sms">
              <i class="fas fa-sms"></i> SMS
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#payment">
              <i class="fas fa-credit-card"></i> Thanh toán
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#ai">
              <i class="fas fa-robot"></i> AI
            </a>
          </li>

        </ul>

        <!-- CONTENT -->
        <div class="tab-content mt-3">

          <!-- GENERAL -->
          <div class="tab-pane fade show active" id="library">
            <h5>Cài đặt chung</h5>
            <p>Quản lý các thiết lập thư viện.</p>

            <app-settings-list
              (idEvent)="edit($event)"
              [settings]="settings$">
            </app-settings-list>
          </div>

          <!-- USER -->
          <div class="tab-pane fade" id="user">
            <h5>Cài đặt người dùng</h5>

            <form [formGroup]="settingsForm" (ngSubmit)="onSubmit()">

              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" formControlName="allowUserRegistration" />
                <label class="form-check-label">Cho phép đăng ký</label>
              </div>

              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" formControlName="requireEmailVerification" />
                <label class="form-check-label">Yêu cầu xác thực email</label>
              </div>

              <div class="form-group">
                <label>Vai trò mặc định</label>
                <select class="form-control w-50" formControlName="defaultUserRole">
                  <option value="member">Thành viên</option>
                  <option value="librarian">Thủ thư</option>
                  <option value="admin">Quản trị</option>
                </select>
              </div>

              <button class="btn btn-primary">
                <i class="fas fa-save"></i> Lưu
              </button>
            </form>
          </div>

          <!-- DISPLAY -->
          <div class="tab-pane fade" id="display">
            <h5>Cài đặt giao diện</h5>

            <div class="form-check">
              <input type="radio" name="theme" checked /> Giao diện sáng
            </div>
            <div class="form-check">
              <input type="radio" name="theme" /> Giao diện tối
            </div>
          </div>

          <!-- DATABASE -->
          <div class="tab-pane fade" id="database">
            <h5>Cài đặt cơ sở dữ liệu</h5>

            <label>Tần suất sao lưu</label>
            <select class="form-control w-50">
              <option>Hàng ngày</option>
              <option>Hàng tuần</option>
              <option>Hàng tháng</option>
            </select>
          </div>

          <!-- NOTIFICATION -->
          <div class="tab-pane fade" id="notification">
            <h5>Cài đặt thông báo</h5>

            <div class="form-check">
              <input type="checkbox" checked /> Thông báo đến hạn
            </div>
          </div>

          <!-- SMS -->
          <div class="tab-pane fade" id="sms">
            <app-twilio-settings></app-twilio-settings>
          </div>

          <!-- PAYMENT -->
          <div class="tab-pane fade" id="payment">
            <app-paypal-settings></app-paypal-settings>
          </div>

          <!-- AI -->
          <div class="tab-pane fade" id="ai">
            <app-openai-settings></app-openai-settings>
          </div>

        </div>

      </div>
    </div>

  </ng-template>
</div>